import styled from 'styled-components'
import { useIntl } from 'react-intl'
import { FormControl, InputLabel, Input, OutlinedInput, InputBaseComponentProps } from '@mui/material'

interface Props {
  name: string
  register: (instance: any, props: Record<any, any>) => any
  required?: boolean
  fullWidth?: boolean
  inputProps?: InputBaseComponentProps
  disabled?: boolean
  outlined?: boolean
  value?: string
  className?: string
  label?: string
  placeholder?: string
  hideLabel?: boolean
}

export default function HcpField(props: Props): JSX.Element {
  const {
    name,
    register,
    required,
    fullWidth,
    inputProps,
    disabled,
    outlined = true,
    value,
    className,
    label,
    placeholder,
    hideLabel = false,
  } = props
  const intl = useIntl()

  const validate = (e: any) => {
    const { key, target } = e
    const { value } = target
    let newValueString = ''
    let newValue = value + key

    // search&replace highlighted text on the input
    if (document.getSelection()) {
      const highlightedText = document.getSelection()?.toString() || ''
      newValueString = value.replace(highlightedText, '')
      newValue = newValueString + key
      if (newValue === '+') {
        newValue = '+0'
      }
    }

    newValueString = newValue.includes('+') ? newValue : `-${newValue}`
    const newValueFloat = parseFloat(newValueString)
    const outsideRange = newValueFloat > 10 || newValueFloat < -54
    const invalidValue = !/^\+?\d{0,2}\.?\d?$/.test(newValue)

    const invalidKeyPressed = !/^\+?\d*\.?\d*$/.test(key)

    if (invalidKeyPressed || (value && (outsideRange || invalidValue))) {
      e.preventDefault()
    }
  }

  const getInputProps = () => {
    const currentInputProps = inputProps || {}
    const requiredText = intl.formatMessage({ id: 'strings.required' })
    if (placeholder && required && outlined) {
      currentInputProps.placeholder = `${placeholder} (${requiredText})`
    } else if (required && outlined) {
      currentInputProps.placeholder = requiredText
    } else if (placeholder && outlined) {
      currentInputProps.placeholder = placeholder
    }
    return currentInputProps
  }

  const ContainerVariant = outlined ? InputContainer : FormControl
  const LabelVariant = outlined ? FieldLabel : InputLabel
  const InputVariant = outlined ? OutlinedInput : Input

  return (
    <ContainerVariant fullWidth={fullWidth || true} margin={'normal'} required={required} className={className}>
      <LabelVariant {...(hideLabel ? { required: false } : {})} htmlFor={name} data-shrink="true">
        {label !== undefined ? label : intl.formatMessage({ id: 'strings.hcpIndex' })}
      </LabelVariant>
      <InputVariant
        name={name}
        type="text"
        {...(register ? register(name, { required: true }) : {})}
        required={required}
        inputProps={getInputProps()}
        disabled={disabled}
        defaultValue={value}
        onKeyPress={validate}
      />
    </ContainerVariant>
  )
}

const InputContainer = styled(FormControl)`
  & .MuiOutlinedInput-root {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    & fieldset {
      border-color: #e4e4e7;
    }

    &:hover fieldset {
      border-color: #e4e4e7;
    }

    &.Mui-focused fieldset {
      border-color: #e4e4e7;
    }
  }

  & .MuiOutlinedInput-input {
    padding: 10px 12px;
  }

  & .MuiSelect-icon {
    color: #8a8a8e;
    font-size: 20px;
  }
  display: flex;
  justify-content: center;
  align-items: flex-end;
  align-self: stretch;
`

const FieldLabel = styled(InputLabel)`
  margin-top: -20px;
  transition: none;
  transform: none;
`
